export default __webpack_public_path__ + "static/media/Path3436.f5c04c8d.svg";